import React from 'react'

const DividerPipe = () => <>&nbsp;|&nbsp;</>

export default DividerPipe
